import useTenantStore from '../store/useTenantStore';
import useAuthStore from '../store/useAuthStore';

/**
 * Hook para acceder a la información del Tenant (cliente) actual.
 * Ahora utiliza Zustand para la gestión de estado global.
 */
export const useTenant = () => {
  const { tenantSettings, loading } = useTenantStore();
  const { tenant: authTenant } = useAuthStore();

  // Priorizar settings cargados del API (pre-login), fallback a la info del auth (post-login)
  const activeTenant = tenantSettings || authTenant || {};

  // Log para depuración (puedes comentarlo después)
  if (!activeTenant.id && !activeTenant.name) {
    console.warn("useTenant: No se encontró información del tenant activa.", { tenantSettings, authTenant });
  }

  return {
    ...activeTenant,
    name: activeTenant.name || activeTenant.nombre || '',
    logo: activeTenant.settings?.logo_url || activeTenant.logo || activeTenant.logo_url,
    primaryColor: activeTenant.settings?.primary_color || activeTenant.primaryColor || activeTenant.primary_color,
    secondaryColor: activeTenant.settings?.secondary_color || activeTenant.secondaryColor || activeTenant.secondary_color,
    features: activeTenant.features_enabled || activeTenant.features || activeTenant.settings?.features || [],
    loading
  };
};

/**
 * Utilidad para extraer el subdominio de forma segura.
 * Maneja casos como localhost, dominios de nivel superior y ambientes de prod.
 */
export const getSubdomain = () => {
  if (typeof globalThis.window === 'undefined') return null;

  const hostname = globalThis.window.location.hostname;
  
  // Si es localhost o una IP, devolvemos un tenant por defecto o null
  if (hostname === 'localhost' || hostname === '127.0.0.1' || /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)) {
    // Para desarrollo, podemos usar un parámetro de URL o un default
    const urlParams = new URLSearchParams(globalThis.window.location.search);
    return urlParams.get('tenant') || 'default';
  }

  const parts = hostname.split('.');
  
  // Si tiene menos de 3 partes (ej: prestanza.com), no hay subdominio
  if (parts.length < 3) return 'default';

  // El subdominio suele ser la primera parte (ej: cliente1.legalcheck.com)
  return parts[0];
};
